<template lang="pug">
  .wrap
    page-title 
      | Reports
      span(slot='subtitle') You can view and control reports on all data within BrApp.
  
</template>

<script>
import PageTitle from "@/shared/components/layout/PageTitle";

export default {
  components: { PageTitle },

  data() {
    return {};
  },
  methods: {}
};
</script>

<style scoped lang="scss"></style>
